// Registrierung „Kanal-Export" für die Shell (Integrator hängt die Arrays in extras/index.tsx ein).
import type { ExtraMenuItem, ExtraRoute } from '../index';
import { ExportChannelDialog } from './ExportChannelDialog';
import { ExportsPage } from './ExportsPage';

export { ExportChannelDialog } from './ExportChannelDialog';
export { ExportsPage } from './ExportsPage';
export { applyExportUpdate, EXPORTS_KEY, EXPORTS_LIST_KEY, exportJobKey } from './realtime';

export const exportsRoutes: ExtraRoute[] = [{ path: '/exports', element: ExportsPage }];

export const exportsMenuItems: ExtraMenuItem[] = [
  { id: 'export-channel', label: 'Kanal exportieren', slot: 'channelHeader', component: ExportChannelDialog, display: 'dialog' },
  { id: 'exports', label: 'Exporte', slot: 'userMenu', to: '/exports' },
];
